export * from './mixpanel';

export const SAVED_CONTENT_API_ROOT = 'bookmarks';
export const SAVED_CONTENT_PER_PAGE = 100;
